import React from 'react';
import { Styled } from '.';
import { useRouter } from 'next/router';
import Image from 'next/legacy/image';
import { Slide } from '../../types';

function BannerSlides({ slideData }: { slideData: Slide | undefined }) {
  const router = useRouter();

  return slideData ? (
    <Styled.HeroBannerContainer onClick={() => router.push(slideData.ctaLink)}>
      <Image
        src={slideData.imageUrl}
        className="call-to-action-button-gtm"
        alt={slideData.title}
        layout="fill"
        objectFit="cover"
        placeholder="blur"
        quality={100}
        blurDataURL="data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImciPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjY2JjYmNiIiBvZmZzZXQ9IjIwJSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2Y5ZjlmOSIgb2Zmc2V0PSI1MCUiIC8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNjYmNiY2IiIG9mZnNldD0iNzAlIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3Qgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIGZpbGw9IiNjYmNiY2IiIC8+CiAgPHJlY3QgaWQ9InIiIHdpZHRoPSI3MDAiIGhlaWdodD0iNDc1IiBmaWxsPSJ1cmwoI2cpIiAvPgogIDxhbmltYXRlIHhsaW5rOmhyZWY9IiNyIiBhdHRyaWJ1dGVOYW1lPSJ4IiBmcm9tPSItNzAwIiB0bz0iNzAwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+Cjwvc3ZnPg=="
      />
      <Styled.HeaderContent>
        <Styled.Wrapper>
          <Styled.Title
            className="call-to-action-button-gtm"
            pattern={slideData.pattern}
          >
            {slideData.title}
          </Styled.Title>
          <Styled.SubTitle
            className="call-to-action-button-gtm"
            dangerouslySetInnerHTML={{
              __html: slideData?.subTitle?.replaceAll('®', '<sup>®</sup>'),
            }}
            pattern={slideData.pattern}
          >
            {/* {slideData.subTitle} */}
          </Styled.SubTitle>
          {slideData.ctaText && (
            <Styled.ShopNowButton pattern={slideData.pattern}>
              <span className="call-to-action-button-gtm">
                {slideData.ctaText}
              </span>
            </Styled.ShopNowButton>
          )}
        </Styled.Wrapper>
      </Styled.HeaderContent>
    </Styled.HeroBannerContainer>
  ) : null;
}

export default BannerSlides;
